module.exports = __webpack_public_path__ + "img/sheet_human_change.67fae1e6.svg";